import React from 'react';
import styles from './InputDisplayOnly.module.scss';

import { InputContainer } from '../InputContainer/InputContainer';
import SVG from 'react-inlinesvg';
interface InputProps {
  label: string;
  value: string | number;
  icon?: string;
}

export const InputDisplayOnly: React.FC<InputProps> = ({
  label,
  icon,
  value,
}) => {
  return (
    <>
      <InputContainer label={label}>
        <div className={styles.InputDisplayOnly}>
          <span className={styles.value}>
            {icon && <SVG src={icon} />}
            {value}
          </span>
        </div>
      </InputContainer>
    </>
  );
};
